/**
 * Triggered with the app's billing status (App#getBillingStatus) whenever it has been loaded or refreshed, so
 * the navbar can show it. It is a separate module because both the app view and the top-up page trigger it.
 */
const BILLING_STATUS_LOADED = Symbol("BILLING_STATUS_LOADED");

/**
 * Triggered by the top-up page when it is opened. The app view then hides its billing banners, since the page
 * itself shows the same information and has the form for paying.
 */
const TOP_UP_PAGE_OPENED = Symbol("TOP_UP_PAGE_OPENED");

export {BILLING_STATUS_LOADED, TOP_UP_PAGE_OPENED};
